import React, { ReactNode } from 'react';

type OnboardingStepProps = {
    optional?: boolean;
    title?: string;
    description?: ReactNode;
    children: React.ReactNode | React.ReactNode[];
};

function OnboardingStep({ optional = false, title, description, children }: OnboardingStepProps): JSX.Element {
    return (
        <div className="p-16 min-w-[500px] h-full flex flex-col">
            <div className="h-full flex flex-col">
                {title && (
                    <div className="mb-8">
                        <h1 className="text-contentPrimary text-3xl font-bold my-2 flex items-end">
                            {title}
                            {optional && <p className="text-sm text-contentSecondary font-medium mb-0.5 ml-1">(optional)</p>}
                        </h1>
                        <p className="text-contentSecondary text-sm font-medium">{description}</p>
                    </div>
                )}
                <div className="grow">{children}</div>
            </div>
        </div>
    );
}

export default OnboardingStep;
